import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';

const Target = ({ bottom, left, popUpBottom, popUpLeft, onClick, debug, discovered, target, running }) => {
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!discovered) {
            onClick(target);
        }
    };

    let className = '';
    let icon = '';

    if (discovered) {
        switch (target.icon) {
            case 'times':
                className = 'bg-[#656D71] text-white';
                icon = faTimes;
                break;
            default:
            case 'check':
                className = 'bg-app-yellow text-app-turquoise';
                icon = faCheck;
                break;
        }
    }

    let classPosition = '';
    switch (target.info.origin) {
        case 'top-left':
        default:
            classPosition = 'top-3 left-3 lg:top-6 lg:left-6';
            break;
        case 'top-right':
            classPosition = 'top-3 right-3 lg:top-6 lg:right-6';
            break;
        case 'bottom-left':
            classPosition = 'bottom-3 left-3 lg:bottom-6 lg:left-6';
            break;
        case 'bottom-right':
            classPosition = 'bottom-3 right-3 lg:bottom-6 lg:right-6';
            break;
    }

    return (
        <div
            className={`
                absolute p-4 md:p-8 lg:p-16 cursor-pointer
                ${debug ? "border border-white" : ""}
            `}
            onClick={handleClick}
            style={{
                left,
                bottom,
            }}
        >
            <div className="relative">
                <button
                    className={`
                        text-md lg:text-2xl w-8 h-8 lg:h-12 lg:w-12 z-10 relative
                        rounded-full flex items-center justify-center
                        target ${className}
                    `}
                    style={discovered ? {
                        boxShadow: '-6px 6px 8px rgba(0, 0, 0, 0.5)',
                    } : {}}
                >
                    {discovered && icon && (
                        <FontAwesomeIcon icon={icon} />
                    )}
                </button>


                {discovered && !running && (
                    <div className={`
                        leading-tight lg:leading-normal bg-app-turquoise rounded-lg p-3
                        rubrik-regular text-white w-[10rem] lg:w-[15rem] xl:w-[20rem] absolute text-[0.65rem] xl:text-md
                        ${classPosition}
                    `}>
                        <p className="rubrik-semibold">
                            {target.info.label ?? ''}
                        </p>

                        <span>
                            {target.info.content}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Target;
